export function isDate(value: any): value is Date {
    return value instanceof Date && !isNaN(value.getTime());
}

export function parseUtcAsLocal(dateStr: string | Date): Date {
  if (dateStr instanceof Date) return dateStr;
  // If a specific offset is not defined, we will assume UTC (Zulu Time)
  if (typeof dateStr === 'string' && !dateStr.endsWith('Z') && !(/[+-]\d{2}:\d{2}$/.test(dateStr))) {
    return new Date(dateStr + 'Z');
  }
  return new Date(dateStr); // already includes Z or is ISO with offset
}